// extracted by mini-css-extract-plugin
export default {"root":"Home_root__+6iv+","banner":"Home_banner__HGLj0","safety":"Home_safety__ow4m+","safetyImage":"Home_safetyImage__BZ1fP"};